import { ModalContext } from "app/app";
import axios from "axios";
import { Pagination } from "components/Pagination";
import { Animate, Grid, Search, Table, ViewContext } from "components/lib";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";

export function VehiclesActive(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState("");

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const { setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/vehicle?page=${page}&search=${search}&company_id=${company_id}&active=true&type=vehicle`
      )
      .then((res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        res.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            year: value.year,
            make: value.make,
            model: value.model,
            VIN: value.vin,
            "VIN Number": value.vin,
            loss_payee: value.loss_payee,
            type: value.type,
            class: value.class,
            bodytype: value.bodytype,
            stated_value: formatter.format(value.stated_value),
            status: value.active ? "Active" : "Inactive",
          });
        });

        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);

        context.notification.show(
          "Failed to load table data",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  async function archiveVehicle(id) {
    await axios
      .patch(`/api/vehicle/${id}`, { active: false, status: "inactive" })
      .then((res) => {
        setLoading(false);

        runAPI(page, searchQueryString);

        context.notification.show(
          "Vehicle archived!",
          "success",
          true,
          "toast",
          "check-circle"
        );
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          "Failed to arquive vehicle.",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  function editVehicle(vehicle) {
    vehicle.active = vehicle.status === "Active" ? true : false;
    delete vehicle.status;

    vehicle.stated_value = Number(
      vehicle.stated_value.replace(/[^0-9.-]+/g, "")
    );

    vehicle.vin = vehicle["VIN Number"];

    setModal({
      name: "vehicle_modal",
      stage: 1,
      data: vehicle,
      mode: "edit",
      action: () => runAPI(page, searchQueryString),
    });
  }

  async function deleteVehicle(vehicle) {
    setModal({
      name: "confirmation",
      data: {
        title: `Delete vehicle`,
        description: `Do you really want to delete this vehicle?`,
      },
      action: async () => {
        setModal("");

        await axios
          .delete(`/api/vehicle/${vehicle.id}`)
          .then((res) => {
            setModal("");
            context.notification.show(
              "Vehicle deleted.",
              "success",
              true,
              "toast",
              "check-circle"
            );

            runAPI(page, searchQueryString, false);
          })
          .catch((err) => {
            setLoading(false);

            context.notification.show(
              "Failed to load table data",
              "error",
              true,
              "toast",
              "x-circle"
            );
          });
      },
    });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, "");
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex" }}>
          <div
            style={{
              width: "150px",
              backgroundColor: "black",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: "default",
            }}
          >
            Active
          </div>
          <div
            onClick={() => {
              window.location.href =
                "/app/company/" + company_id + "/vehicles/archived";
            }}
            style={{
              backgroundColor: "#EAEAEA",
              width: "150px",
              color: "#090E3480",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: "pointer",
            }}
          >
            Archived
          </div>
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              badge={{
                col: "status",
                condition: [
                  { value: "Active", color: "green" },
                  { value: "Inactive", color: "red" },
                ],
              }}
              hide={[
                "link",
                "id",
                "class",
                "type",
                "bodytype",
                "VIN",
                "loss_payee",
              ]}
              actions={{
                custom: [
                  {
                    icon: "edit",
                    tooltip: "Edit this vehicle",
                    action: (row) => editVehicle(row),
                  },
                  {
                    icon: "archive",
                    tooltip: "Archive this vehicle",
                    action: (row) => archiveVehicle(row.id),
                  },
                  {
                    icon: "trash",
                    tooltip: "Delete this vehicle",
                    action: (row) => {
                      deleteVehicle(row);
                    },
                  },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
